// @flow
import React from 'react';
// import EventsCard from 'components/event/EventsCard';
import DynamicEventsCardContainer from 'containers/event/DynamicEventsCardContainer';
import Bulletin from 'components/hub/Bulletin';
import Management from 'containers/hub/ManagementContainer';
import type { HomeCardType } from 'types/Settings';

export type StateProps = {
  bulletin_officiel: HomeCardType
};

const Hub = (props: StateProps) => (
  <section className="container section">
    <div className="row">
      <Management />
      {props.bulletin_officiel && props.bulletin_officiel.object_id > 0 && 
      <Bulletin
        url={`/${props.bulletin_officiel.parent_slugs[1]}/${props.bulletin_officiel.parent_slugs[2]}/${props.bulletin_officiel.object_slug}`}
        img={props.bulletin_officiel.featured_image}
        title={props.bulletin_officiel.title}
        description={props.bulletin_officiel.description}
        hub={true}
      />}
      <div className="col col-md-4 col-lg-3">
        <h2 className="mb-3">Événements</h2>
        <DynamicEventsCardContainer highlightFirst />
      </div>
    </div>
  </section>
);

export default Hub;
